module.exports = __webpack_public_path__ + "img/qq.eb3a433e.svg";